<template>
  <div id="albumcategory">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">相簿分類</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">相簿</li>
              <li class="breadcrumb-item active">相簿分類</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-album" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-9">
            列表排序方式與頁面「
            <router-link :to="{ name: 'albumIndex' }" tag="a" target="_blank"
              >相簿 — 相簿類型</router-link
            >」關聯
          </div>
          <div class="col-sm-3">
            <el-button type="primary" @click="addAlbum()">
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i>新增分類
            </el-button>
            <el-button type="info" @click="sortout()">
              <i class="nav-icon fas fa-save fa-sm mr-1"></i>保存當前排序
            </el-button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table
                  :data="albumTypeList"
                  border
                  row-key="id"
                  v-if="isShow"
                  v-loading="mloading"
                >
                  <el-table-column width="40">
                    <template>
                      <i class="fas fa-arrows-alt-v handle"></i>
                    </template>
                  </el-table-column>
                  <el-table-column label="相簿分類">
                    <template slot-scope="scope">
                      <span class="typestyle">{{ scope.row.sgL_NewName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="相簿數量" prop="sgL_NViewQuantity">
                  </el-table-column>
                  <el-table-column
                    label="相片數量"
                    prop="sgL_ActivityQuantity"
                  ></el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="editAlbumType(scope.row.id)"
                        >編輯</el-button
                      >
                      <el-popconfirm
                        title="確定刪除嗎？"
                        @onConfirm="DeleteAlbumType(scope.row.id)"
                      >
                        <el-button size="mini" type="danger" slot="reference"
                          >刪除</el-button
                        >
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
      <!-- Modal: 新增/編輯相簿分類 -->
      <div class="modal fade" id="modal-category--set">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">新增/編輯相簿分類</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <label for="b-collection-image"
                    >相簿分類圖（建議尺寸：300x200）</label
                  >
                  <!-- Album Category Image -->
                  <div class="b-album-thumbnail w-25">
                    <div class="b-album-responsive mb-2">
                      <div class="b-album-category-sizer"></div>
                      <div class="b-album-content">
                        <div class="b-layout h-100 align-center ma-0">
                          <div class="b-layout-flex">
                            <div class="text-center o-60">
                              <i class="fas fa-image fa-2x"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  ＜此處使用上傳插件，上傳後即時顯示圖片＞
                  <button
                    type="button"
                    class="btn btn-block btn-default btn-sm mb-3"
                    data-toggle="modal"
                    data-target="#modal-featured--set"
                  >
                    <i class="nav-icon fas fa-image mr-1"></i> 上載自訂縮圖
                  </button>
                  <!-- /.Album Category Image -->
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="b-album-category">相簿分類</label>
                    <input
                      type="text"
                      class="form-control"
                      id="b-album-category"
                      placeholder="e.g. 重機、路跑、單車&hellip;"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
              >
                取消
              </button>
              <button
                type="button"
                class="btn btn-primary category--set---success"
                data-dismiss="modal"
              >
                保存
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal: 新增/編輯相簿分類 -->

      <el-dialog
        title="新增/編輯相簿分類"
        :close-on-click-modal="false"
        :visible.sync="editIsShow"
      >
        <el-form
          :model="editAlbum"
          ref="editAlbum"
          :rules="albumRules"
          label-width="120px"
        >
          <el-form-item label="上傳">
            <div class="row">
              <div class="col-4">
                <!-- Album Category Image -->
                <div>
                  <p class="type_title">
                    <i style="color: red">*</i>
                    <span>相簿類型封面上傳（只支援jpg格式）</span>
                  </p>
                  <el-upload
                    :action="uploadImageUrl + '&id=' + this.user.userId"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    class="avatar-uploader"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>

                <!-- /.Album Category Image -->
              </div>
            </div>
          </el-form-item>
          <el-form-item label="相簿分類" prop="sgL_Type_Name">
            <el-input v-model="editAlbum.sgL_Type_Name"></el-input>
          </el-form-item>

          <el-form-item>
            <el-input type="hidden" v-model="editAlbum.id"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editIsShow = false">取消</el-button>
          <el-button type="primary" @click="submitForm('editAlbum')"
            >確定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import Sortable from "../../../node_modules/sortablejs";
import base from "../../api/httpApi/base";
export default {
  data() {
    return {
      editAlbum: {
        sgL_Type_Name: null,
        id: null,
        imageId: null,
      },
      user: null,
      editIsShow: false,
      albumTypeList: null,
      isShow: true,
      uploadImageUrl: `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=imageclass`,
      mloading: true,
      albumRules: {},
      imageUrl: null,
    };
  },
  created() {
    //从store中读取user数据
    this.user = this.$store.getters.getUser;
    this.getAll();
  },
  mounted() {
    // document.body.ondrop = function(event) {
    //   event.preventDefault()
    //   event.stopPropagation()
    // }
    this.rowDrop(); //用于拖拽排序进来时加载
    // this.columnDrop(); //用于拖拽排序进来时加载
  },
  methods: {
    getAll() {
      this.$store.dispatch("getCommonTypeDesk", 70).then((res) => {
        this.albumTypeList = res; //相簿類型
        if (this.albumTypeList != null) {
          this.mloading = false;
        }
      });
    },
    //添加编辑影片類型
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editAlbum.id != null) {
            //修改
            let params = {
              sgL_NewName: this.editAlbum.sgL_Type_Name,
              sgL_ImageId: this.editAlbum.imageId,
              id: this.editAlbum.id,
               sgL_TypeT: 70,
            };
            this.$api.commons.EditCommonType(params).then((res) => {
              if (res.data.success) {
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "修改失敗",
                });
              }
              this.editIsShow = false;
              //重新查詢數據
              this.getAll();
            });
          } else {
            //添加
            let params = {
              sgL_NewName: this.editAlbum.sgL_Type_Name,
              sgL_ImageId: this.editAlbum.imageId,
              sgL_Remark: "圖冊類型",
              sgL_TypeT: 70,
            };
            this.$api.commons.AddCommonType(params).then((res) => {
              if (res.data.success) {
                this.$message({
                  type: "success",
                  message: "添加成功",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "添加失敗",
                });
              }
              this.editIsShow = false;
              //重新查詢數據
              this.getAll();
            });
          }
        }
      });
    },
    //打开新增页面
    addAlbum() {
      this.editAlbum = this.$options.data().editAlbum; //置空表单
      this.imageUrl = null;
      this.editIsShow = true;
    },
    //打开修改影片类型页面
    editAlbumType(id) {
      let msg = "";
      this.editAlbum = this.$options.data().editAlbum; //置空表单
      this.editIsShow = true;
      this.GetSingleType(id).then((res) => {
        if (res.data.success) {
          let typeModel = res.data.result;
          if (typeModel == null) return;
          //赋值给model
          console.log(typeModel)
          this.editAlbum.sgL_Type_Name = typeModel.sgL_NewName;
          this.editAlbum.id = typeModel.id;
          this.editAlbum.imageId = typeModel.sgL_ImageId;
          this.imageUrl=typeModel.sgL_ImageUrl;
        } else {
          Message({
            type: "warning",
            message: "未找到該信息",
          });
        }
      });
    },
    //根据Id获取数据
    async GetSingleType(id) {
      let params = { Id: id };
      return this.$api.commons.getCommonType(params);
    },
    //删除数据
    DeleteAlbumType(id) {
      let params = {
        Id: id,
      };
      this.$api.commons.DeleteCommonType(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "刪除成功",
          });
        } else {
           this.$message({
            type: "error",
            message: res.data.error.message,
          });
        }
        this.getAll();
      });
    },
    //保存排序
    sortout() {
      this.sortList = [];
      this.albumTypeList.map((item, index) => {
        //拖拽时改变了data数据顺序、所以直接取index就可以取到排序值
        let sort = { id: item.id, sortID: index };
        this.sortList.push(sort);
      });
      this.$api.commons.albumCommonSort(this.sortList).then((res) => {
        if (res.data.success) {
          Message({ type: "success", message: "保存成功" });
        } else {
          Message({ type: "error", message: res.data.error.message });
        }
      });
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.albumTypeList.splice(oldIndex, 1)[0];
          // if (currRow != null) {
          //   //查找数组中是否已经操作过该条数据
          //   let index = _this.sortList.findIndex(item => {
          //     if (item.id == currRow.id) {
          //       return true;
          //     }
          //   });
          //   if (index > -1) {
          //     //删除已操作过的数据
          //     _this.sortList.splice(index, 1);
          //   }
          //   //赋值添加sort
          //   currRow.sgL_OrderBy = newIndex;
          //   let sort = { id: currRow.id, sortId: currRow.sgL_OrderBy };
          //   _this.sortList.push(sort);
          // }
          _this.albumTypeList.splice(newIndex, 0, currRow);
        },
      });
    },
    // 列拖拽
    // columnDrop() {
    //   const wrapperTr = document.querySelector('.el-table__header-wrapper tr');
    //   const _this = this;
    //   Sortable.create(wrapperTr, {
    //     animation: 180,
    //     delay: 0,
    //     onEnd: evt => {
    //       const oldItem = _this.albumTypeList[evt.oldIndex];
    //       _this.albumTypeList.splice(evt.oldIndex, 1);
    //       _this.albumTypeList.splice(evt.newIndex, 0, oldItem);
    //     }
    //   })},

    //#region 上传图片
    handleAvatarSuccess(res, file) {
      this.editAlbum.imageId = res.result.uploadId;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const ispng = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !ispng) {
        this.$message.error("上传封面图片只能是 JPG /png格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传封面图片大小不能超过 5MB!");
      }
      return (isJPG || ispng) && isLt5M;
    },
  },
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminAlbum/albumCategory.vue